import React, { ComponentProps, FC, memo } from 'react'

import { Button as RoovStandardButton } from '@style-port/roov-ui-components-react'
import { ButtonInner, ButtonInnerProps } from 'src/components/atoms/inputs/ButtonInner'

type ButtonProps = ComponentProps<'button'>
type Props = Omit<ButtonInnerProps, 'buttonType'> & {
  isLoading?: boolean
} & ButtonProps

export const ConversionButton: FC<Props> = memo(
  ({
    size = 'm',
    children,
    text,
    prependIconPath,
    appendIconPath,
    isLoading = false,
    disabled,
    ...otherProps
  }) => {
    return (
      <RoovStandardButton
        buttonType="conversion"
        size={size}
        disabled={isLoading || disabled}
        {...otherProps}
      >
        <ButtonInner
          buttonType="conversion"
          size={size}
          text={text}
          prependIconPath={prependIconPath}
          appendIconPath={appendIconPath}
          isLoading={isLoading}
          disabled={disabled}
        >
          {children ?? null}
        </ButtonInner>
      </RoovStandardButton>
    )
  }
)
